import React, { useState, useEffect, useContext } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import parse from 'html-react-parser';
import { Dialog } from 'primereact/dialog';
import Swal from 'sweetalert2'
import * as request from "../admin/lib/lib";
import { ParameterContext } from '../contexts/ParameterContext';

export function Ratings() {
    const [data, setData] = useState(null);
    const [schData, setSchData] = useState();
    const [alg, setAlg] = useState();
    const { parameters } = useContext(ParameterContext);

    const [visible, setVisible] = useState(false);

    const randomRanking = parameters?.nomParameters.find(x => x.param_name == 'RANDOM_RANKING').value;
    console.log(parameters)
    console.log(randomRanking)

    useEffect(() => {

        const populateRatings = async () => {
            try {
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'Reference/LastRanking');
                //const data = await response.json();

                if (response.status == 400) {
                    throw new Error(response.message)
                }

                setData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };


        const populateAlg = async () => {
            try {
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'Ranking/RandomSoftware');
                //const data = await response.json();

                if (response.status == 400) {
                    throw new Error(response.message)
                }

                setAlg(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };


        populateRatings();
        populateAlg();
        document.title = `Резултати`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.


    const handleSchoolClick = async (sid, sname) => {

        try {
            const response = await request.get(process.env.REACT_APP_BACKEND_URL + `Reference/SchoolRanking/${sid}`);
            if (response.status === 400) {
                Swal.fire({
                    title: 'Внимание!',
                    text: data.message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });

                return;
            }
            else {
                toggleDialog(sname);
                setSchData(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const toggleDialog = (sname) => {
        setVisible(true);
    };
    const toggleDialogHide = () => {
        setVisible(false);
    };



    return (
        <div className="mb-10">
            <div className="title_rating">Резултати от класиране</div>
            {!data ? <div className="no_rating">Няма обявено класиране.</div> : (
                <TabView>
                    <TabPanel header="Резултати">
                        <p className="m-0">
                            <table className="table table-striped">
                                <tbody>
                                    {data && data.schools.map((sch, index) => (
                                        <tr key={sch.id}>
                                            {/* Correctly attaching the onClick handler */}
                                            <td onClick={() => handleSchoolClick(sch.id, sch.name)} style={{ cursor: 'pointer' }}>{sch.name}</td>
                                        </tr>

                                    ))}
                                </tbody>
                            </table>
                        </p>
                    </TabPanel>

                    {data.spR_KLASIRANE_UCHASTWALI_PUBLIC &&
                        <TabPanel header="Участвали в класирането">
                            <p className="m-0 w-100">
                                {parse(data.spR_KLASIRANE_UCHASTWALI_PUBLIC)}
                            </p>
                        </TabPanel>
                    }

                    {randomRanking == 1 &&
                        <TabPanel header="Случайно число">
                            <p className="m-0">
                                {parse(data.spR_RANDOM)}
                            </p>
                        </TabPanel>
                    }

                    {randomRanking == 1 &&
                        <TabPanel header="Алгоритъм" >
                            <p className="m-0">
                                Брой деца участвали в класирането : {alg && alg.childrenCount} <br />
                                Линк към софтуер за определяне на случайно число : <a href={alg && alg.randomSoftwareLink}>Изтегли</a>

                            </p>
                        </TabPanel>
                    }
                </TabView>
            )}

            <Dialog
                header={''}
                visible={visible}
                style={{ width: '100%', height: '100%', overflow: 'auto' }}
                onHide={() => toggleDialogHide()}
            >
                {schData ? parse(schData.spR_KLASIRANE_PUBLIC) : ''}
            </Dialog>

            <div className="mt-5 mb-5">
            </div>


        </div >


    );
}

export default Ratings;